import { render, staticRenderFns } from "./chat-status-dialog.vue?vue&type=template&id=8a052458&scoped=true"
import script from "./chat-status-dialog.vue?vue&type=script&lang=js"
export * from "./chat-status-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a052458",
  null
  
)

export default component.exports